module.exports = __webpack_public_path__ + "static/media/solidity-expert.7a7a20a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/solidity-expert.png
// module id = 1468
// module chunks = 146